var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 68,
    viewBox: "0 0 58 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_7596_16516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 27.3335C50 38.9315 33.6667 57.7835 29 57.7835C24.3333 57.7835 8 38.9315 8 27.3335C8 15.7355 17.402 6.3335 29 6.3335C40.598 6.3335 50 15.7355 50 27.3335Z",
    fill: "#D64C4C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9566 20.6055L29.5038 26.4829L16.3999 19.5748L27.7332 13.7998L40.9566 20.6055Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9572 32.2749L29.5044 38.6493V26.4828L40.9572 20.6055V32.2749Z",
    fill: "#D2DEE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3999 19.5752V31.9512L29.5038 38.6498V26.4833L16.3999 19.5752Z",
    fill: "#EAF0F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6279 21.8042V25.0523L21.9083 24.7307L23.6399 26.931L23.7277 23.4368L20.6279 21.8042Z",
    fill: "#DCDCEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7927 17.4328L31.5466 15.7612L20.6279 21.8043L23.7277 23.4369L34.7927 17.4328Z",
    fill: "#F2EFF7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_7596_16516",
    x: 0,
    y: 0.333496,
    width: 58,
    height: 67.4502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.113725 0 0 0 0 0.223529 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7596_16516"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_7596_16516"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.643137 0 0 0 0 0.670588 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7596_16516",
    result: "effect2_dropShadow_7596_16516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7596_16516",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapMarker);
export default __webpack_public_path__ + "static/media/icon-map-marker.250536f42937491882d1200b3fc07be0.svg";
export { ForwardRef as ReactComponent };